var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.396 7.799l-3.024 1.62a.41.41 0 00-.022.71l.756.468a5.452 5.452 0 01-9.436-2.53.778.778 0 00-1.526.306 7.01 7.01 0 0012.3 3.053l.823.51a.41.41 0 00.626-.335l.108-3.427a.41.41 0 00-.605-.375zM13.885 5.627a7.009 7.009 0 00-12.3-3.059l-.854-.529a.41.41 0 00-.626.335l-.108 3.427a.41.41 0 00.6.374l3.024-1.62a.41.41 0 00.022-.71l-.724-.449a5.452 5.452 0 019.431 2.536.779.779 0 001.527-.306z",
    fill: "currentColor"
  })));
}

export default SvgIconSwitch;